import React from 'react';
import {
  Button,
  DialogTitle,
  DialogHeader,
  DialogDescription,
} from '@readcloud/ui';
import { useStepper } from '../Stepper/Stepper';

type Props = { steps: { label: string; id: string; description: string }[] };

export const UploadWizardHeader = ({ steps }: Props) => {
  const { activeStep } = useStepper();

  return (
    <DialogHeader className="rc-mt-6">
      <DialogTitle>{steps[activeStep].label}</DialogTitle>
      <DialogDescription>{steps[activeStep].description}</DialogDescription>
    </DialogHeader>
  );
};
